#######
# Start the app!
#
# Determines which application to run.
#
# These are the available applications at this time: 
#
#     franklin: The main considerit application
#     product_page: The considerit homepage for marketing considerit
#     proposal_embed: an embedable, read-only representation of a proposal

( ->

  # Add defined styles

  style = document.createElement('style')
  style.type = 'text/css'
  if style.styleSheet
    style.styleSheet.cssText = window.styles
  else
    style.appendChild document.createTextNode(window.styles)

  document.body.appendChild style

  React.renderComponent Saas({key: 'saas_root'}), document.getElementById('content')


)()


/** WEBPACK FOOTER **
 ** ./@client/bootstrap_loader.coffee
 **/